module.exports = __webpack_public_path__ + "static/parade-2019-house15-6c0fe4a155d20e87e4d95d61ee6476ed.jpg";